import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {REPORT_CLOSE_TO_SENIOR_COACH_RANK} from '/enum/records.enum';
import {withTranslation} from '/provider/TranslationProvider';

import CloseToRankReportContent from '../CloseToRankReportContent';

import {styles} from './CloseToSeniorCoachReportContent.style';

// Define the types for the props
interface CloseToSeniorCoachReportContentProps {
  tt: (key: string, fallback: string) => string;
  recordData: Record<string, any>;
}

export const CloseToSeniorCoachReportContent: React.FC<
  CloseToSeniorCoachReportContentProps
> = ({
  tt = (key: string, fallback: string) => fallback, // Default function for tt if not provided
  recordData = {}, // Default value for recordData if not provided
}) => {
  const extras = get(recordData, '__extras', {});
  const {rankProgression} = extras;

  return (
    <View>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Close To Senior Coach')}</Text>
        </Gutter>
      </View>
      <CloseToRankReportContent
        progressionData={rankProgression}
        report={REPORT_CLOSE_TO_SENIOR_COACH_RANK}
      />
    </View>
  );
};

export default withTranslation('reportCardContent.closeToSeniorCoach')(
  CloseToSeniorCoachReportContent,
);
